import Head from "next/head";

type Props = {
	title: string;
	description: string;
	keywords: string;
	image?: string;
	url?: string;
};

const SEO = (props: Props) => {
	const { title, description, keywords, image, url } = props;
	return (
		<Head>
			<title>{title ? `${title}` : `oneshot.earth`}</title>
			<meta key="description" name="description" content={description} />
			<meta key="keywords" name="keywords" content={keywords} />
			<meta key="og:type" property="og:type" content="website" />
			<meta key="og:title" property="og:title" content={title} />
			<meta key="og:description" property="og:description" content={description} />
			<meta key="og:image" property="og:image" content={image || "https://pilot.ocp.earth/og-banner.jpg"} />
			<meta key="og:url" property="og:url" content={url} />
			<meta key="twitter:card" property="twitter:card" content="summary_large_image" />
		</Head>
	);
};

SEO.defaultProps = {
	title: undefined,
	description: "oneshot.earth",
	keywords: "oneshot.earth",
	image: "/images/nextjs.png",
};

export default SEO;
